@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.sorting {
  position: relative;
  @include cxy.grid;
  grid-area: main !important;
  grid-template-areas: 'hero' ' categories' 'sidebar' 'section';
  grid-template-rows: 150px auto;
}
@media (min-width: 801px) {
  .sorting {
    grid-template-rows: 82px auto;
  }
}
@media (min-width: 801px) {
  .sorting {
    grid-template-areas: 'hero hero' 'sidebar categories' 'sidebar section';
    grid-template-rows: max-content 64px auto;
    grid-template-columns: 275px auto;
    column-gap: var(--cxy-spacing-xsm);
  }
}
